import type { Paginated } from "@/configs/request";
import type { AuditLogEntry, AuditLogFilter } from "@/types";

import { BaseApi } from "./base.api";

/**
 * Audit jurnali — faqat O'QISH.
 *
 * Yozish, tahrirlash va o'chirish metodlari yo'q va bo'lmaydi:
 * tahrirlash mumkin bo'lgan audit auditning o'zi emas. Yozuvlarni
 * backend interceptor'i qo'yadi, adminka esa ularni faqat ko'radi.
 */
class AdminAuditApi extends BaseApi {
  private readonly baseUrl = "/admin/audit";

  /** Ruxsat `audit.read`. */
  list(filter: AuditLogFilter = {}) {
    return this.request<Paginated<AuditLogEntry>>(this.baseUrl, { query: { ...filter } });
  }
}

export const adminAuditApi = new AdminAuditApi();
